import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const m = i((o, a) => /* @__PURE__ */ e.jsx(
  l,
  {
    ref: a,
    ...o,
    image: (r) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...r,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M16 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8M9 24a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8m16-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
m.displayName = "Acne3Icon";
export {
  m as Acne3Icon,
  m as default
};
//# sourceMappingURL=index.js.map
